import React from 'react';
import Form from '../../../../form/field';
import { makeStyles } from '@material-ui/core/styles';
import Utils from '../../../../utils';
var useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    '&$disabled': {
      color: '#555',
      opacity: 1,
      backgroundColor: '#eee'
    },
    '&$disabled $notchedOutline': {
      borderColor: 'rgba(0, 0, 0, 0.23)'
    }
  },
  notchedOutline: {},
  disabled: {
    color: '#555',
    backgroundColor: '#eee'
  },
  input: function input(props) {
    return {
      backgroundColor: props.disabled ? '#eee' : 'white'
    };
  }
}, {
  name: 'ECFormFieldText'
});

var FormFieldText = function FormFieldText(props) {
  var disabled = props.disabled,
      InputProps = props.InputProps,
      error = props.error;
  var classes = useStyles({
    disabled: disabled
  });
  var textInputProps = Utils.deepMerge(InputProps, {
    classes: classes
  });
  return React.createElement(Form.Input.Text, Object.assign({}, props, {
    InputProps: textInputProps,
    FormHelperTextProps: {
      style: {
        marginTop: 4,
        marginLeft: 0
      },
      className: error ? 'help-error' : 'help-block'
    }
  }));
};

export default React.memo(FormFieldText);